import { render } from "./ModuleOrMenu.vue?vue&type=template&id=3e56d718&scoped=true"
import script from "./ModuleOrMenu.vue?vue&type=script&lang=js"
export * from "./ModuleOrMenu.vue?vue&type=script&lang=js"

import "./ModuleOrMenu.vue?vue&type=style&index=0&id=3e56d718&scoped=true&lang=css"

import exportComponent from "D:\\laragon\\www\\subeasy\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e56d718"]])

export default __exports__